import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { class: "two-column-grid" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src", "alt"]

import Page from "../components/shared/layout/Page.vue";
import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";
import router from "../router";
import { useRoute } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'LenderTile',
  setup(__props) {

const store = useStore();
const route = useRoute();

const pageRef = ref<InstanceType<typeof Page> | null>(null);

const creditUnions = computed(() => store.state.applicationsModule.creditUnions || []);

function getLenderApplications(lenderId: number, subdomain: string) {
  const lenderApps = store.state.applications.filter((c: any) => c.lenderId === lenderId);

  const query = route.query as any;

  if (lenderApps.length === 1) {
		store.dispatch("applicationsModule/setLenderId", lenderApps[0]?.lenderId);
    localStorage.setItem("slc-lid", "" + lenderId);
    store.dispatch("setApplications", lenderApps);
    router.push({
      path: `/applications/${lenderApps[0].referenceId}`,
      query,
    });
  } else {
    // Assuming they have more than one we send them to applications instead
    query.lid = lenderId;
    query.lender = subdomain;
    router.push({ path: "/applications", query });
  }
}

async function hydrateStore() {
  if (store.state.applications.length <= 0) {
    const query = route.query as any;
    router.push({
      path: `/`,
      query,
    });
  }
}

onMounted(async () => {
  pageRef.value?.setLoading(true);
  await hydrateStore();
  pageRef.value?.setLoading(false);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Page, {
    ref_key: "pageRef",
    ref: pageRef
  }, {
    default: _withCtx(() => [
      (creditUnions.value.length > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _cache[0] || (_cache[0] = _createElementVNode("p", { class: "lender-header" }, " Select a lender according to which application you would like to review. ", -1)),
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(creditUnions.value, (lender) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: lender.lenderId
                }, [
                  _createElementVNode("a", {
                    href: "#",
                    class: "lender-img",
                    onClick: ($event: any) => (getLenderApplications(lender.lenderId, lender.subdomain))
                  }, [
                    _createElementVNode("img", {
                      src: lender.image,
                      alt: `${lender.subdomain}_Logo`,
                      class: "icon-banner"
                    }, null, 8, _hoisted_4)
                  ], 8, _hoisted_3)
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 512))
}
}

})